/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationConfirmationSmsCodeAliases {
  BUTTON_CONFIRM = 'button-confirm',
  BUTTON_CONFIRM_ACTION = 'button-confirm-action',
  BUTTON_RESEND_SMS_CODE = 'button-resend-sms-code',
  BUTTON_RESEND_SMS_CODE_ACTION = 'button-resend-sms-code-action',
  CONTEXTUAL_BAR_MAIN_CONTEXT_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'contextual-bar-main-context-account-creation-confirmation-sms-code',
  FORM_SEND_SMS_CODE = 'form-send-sms-code',
  GLOBAL_ACTIONS_RESEND_CONFIRMATION_BUTTONS_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'global-actions-resend-confirmation-buttons-account-creation-confirmation-sms-code',
  INPUT_SMS_CODE = 'input-sms-code',
  LAYOUT_FORMULARY_ACTIONS_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'layout-formulary-actions-account-creation-confirmation-sms-code',
  LAYOUT_RESEND_CONFIRMATION_BUTTONS_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'layout-resend-confirmation-buttons-account-creation-confirmation-sms-code',
  LAYOUT_RESEND_CONTINUE_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'layout-resend-continue-account-creation-confirmation-sms-code',
  LOADER_SEND_SMS_CODE = 'loader-send-sms-code',
  MODAL_SEND_SMS_CODE = 'modal-send-sms-code',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_BTN_CONTINUE = 'panel-btn-continue',
  PANEL_BTN_RESEND = 'panel-btn-resend',
  PANEL_BTNS_ACTIONS = 'panel-btns-actions',
  PANEL_CONFIRMATION_BUTTON_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-confirmation-button-account-creation-confirmation-sms-code',
  PANEL_EXTRA_CONTINUE_BUTTON_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-extra-continue-button-account-creation-confirmation-sms-code',
  PANEL_EXTRA_RESEND_BUTTON_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-extra-resend-button-account-creation-confirmation-sms-code',
  PANEL_FORMULARY_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-formulary-account-creation-confirmation-sms-code',
  PANEL_INNER_RESEND_CONTINUE_BUTTONS_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-inner-resend-continue-buttons-account-creation-confirmation-sms-code',
  PANEL_LOADER_SEND_SMS_CODE = 'panel-loader-send-sms-code',
  PANEL_RESEND_BUTTON_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-resend-button-account-creation-confirmation-sms-code',
  PANEL_RESEND_CONTINUE_BUTTONS_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-resend-continue-buttons-account-creation-confirmation-sms-code',
  PANEL_RESEND_TEXT_INFORMATION_ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'panel-resend-text-information-account-creation-confirmation-sms-code',
  PANEL_TEXT_INFORMATION_RESEND_SMS = 'panel-text-information-resend-sms',
  SEND_SMS_CODE_FIELD = 'send-sms-code-field',
  SEND_SMS_CODE_PANEL = 'send-sms-code-panel',
  TEXT_INFORMATION_RESEND_SMS_CODE = 'text-information-resend-sms-code',
  TEXT_INFORMATION_SMS_CHECK = 'text-information-sms-check',
  TEXT_INFORMATION_SMS_CODE = 'text-information-sms-code',
}
export { AccountCreationConfirmationSmsCodeAliases };
